/*
 * The lobby, all three surfaces. Moved out of `pages/Session/steps/Lobby` when
 * the read-only run sheet arrived and the same copy started being needed twice.
 */

export const LOBBY_COPY = {
  /** The facilitator's side. */
  facTitle: "The table is set.",
  facBody: "Send the link and watch the seats fill as you tune the rules.",

  /** The ring, shared by the facilitator and anyone waiting. */
  emptySeats: "No one has taken a seat yet.",
  /* The dashed chair. Not "one person is missing" — nothing knows how many were
   * invited — but "there is room for one more", which is all it can honestly
   * say. */
  emptySeat: "Empty seat",
  seated: (seated: number) => `${seated} seated`,
  waitingForOthers: "Waiting for others to join…",
  lobbyTitle: "Session lobby",
  copyLink: "Copy the join link",
  copiedLink: "Join link copied",

  /*
   * A guest's waiting room, which is the whole screen until the room starts.
   * They typed their name on the join screen a moment ago, so this asks nothing
   * of them: the table, and the one thing they can tell the facilitator.
   */
  waitingTitle: "The room is filling up.",
  waitingLine: "Pull up a chair.",
  waitingLineAllIn: "Waiting on the facilitator.",

  /** A participant's own card, behind a disclosure on the waiting screen. */
  meTitle: "How you appear to the room",
  nameLabel: "Your name",
  namePlaceholder: "Ana Silva",
  roleLabel: "Your title, optional",
  rolePlaceholder: "Product, Ops, CTO",
  readyCta: "I'm ready",
  readyDone: "Ready — tap to undo",
  editSeat: "Change how you appear",
  editSeatOpen: "Hide your details",
  hidePlan: "Hide the plan",

  /*
   * The run sheet. The room cannot change any of this, but showing it answers
   * the question everyone in a workshop actually has — how long is this — and it
   * is the only place the optional rounds being off is visible to a guest.
   */
  planLabel: "Today's session",
  planTotal: "Total",
  planMinutes: (minutes: number) => `${minutes} min`,
  planTotalMinutes: (minutes: number) => `~${minutes} min`,
} as const
